import fetch from './fetch';
import { GET } from './constants';

const parseQueryParams = (queryParams) => {
  const enc = encodeURIComponent;
  return Object.keys(queryParams)
    .map((k) => {
      if (!queryParams[k]) return undefined;
      return `${enc(k)}=${enc(queryParams[k])}`;
    })
    .filter((x) => x)
    .join('&');
};

const get = (params, network) => {
  params.method = GET;
  if (params.query) {
    params.api += `?${parseQueryParams(params.query)}`;
  }
  return fetch(params, network);
};

export default get;



// WEBPACK FOOTER //
// ./src/api/get.js